module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_custom_1-44d2e1f1d408159224cc63cbd86c3f80.jpg";